<template>
  <div>
    <!-- <v-row v-if="switchForm">
      <v-col class="d-flex justify-center align-center">
      </v-col>
    </v-row> -->

    <div v-if="readyToRender" :class="['px-2', switchForm ? 'pt-5' : 'pt-16']">


      <div>
        <div class="mx-auto register-title" style="max-width:768px;">
          <h2 class="text-center font-weight-bold mb-4">Cadastre seu veículo na The Media Trade</h2>
        </div>

        <v-stepper alt-labels max-width="768" :class="['mx-auto', 'mt-1 ', 'mb-n6', 'step-head', '--register-stepper']"
          elevation="0" :value="step">
          <v-stepper-header :class="switchForm ? '--top-extra' : ''">

            <v-card width="100%">


              <v-img v-if="switchForm"
                :src="`https://lion-web-site-n-virginia.s3.amazonaws.com/whitelabel/${switchForm}-banner.jpg`" class=""
                height="60" max-width="768"></v-img>
            </v-card>
            <v-stepper-step step="1" :complete="step > 1"
              :color="step > 1 ? 'green' : (step == 1 ? 'primary' : 'grey')">
              {{ $t('register.steps.step_1') }}
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="2" :complete="step > 2"
              :color="step > 2 ? 'green' : (step == 2 ? 'primary' : 'grey')">
              {{ $t('register.steps.step_2') }}
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="3" :complete="step > 3"
              :color="step > 3 ? 'green' : (step == 3 ? 'primary' : 'grey')">
              {{ $t('register.steps.step_3') }}
            </v-stepper-step>
          
          </v-stepper-header>
        </v-stepper>
      </div>
      <div :style="switchForm ? 'height: 80px' : `height: 10px`"></div>
      <v-slide-x-transition>
        <RegisterUser :assets="assets" :country="country" @change-country="country = $event" @set-hash="setHash($event)"
          @set-generic-error="setGenericError($event)" @change-step="step = $event" v-if="step == 1"></RegisterUser>
      </v-slide-x-transition>
      <v-slide-x-transition>
        <RegisterCompany :assets="assets" :country="country" :hash="hash" :user-phone="userPhone" @set-hash="setHash($event)"
          @set-generic-error="setGenericError($event)" @change-step="step = $event" v-if="step == 2"></RegisterCompany>
      </v-slide-x-transition>
      <v-slide-x-transition>
        <RegisterUpload :assets="assets" :country="country" :hash="hash" :whitelabel-checkbox="whitelabel"
          @set-hash="setHash($event)" @set-generic-error="setGenericError($event)" @change-step="step = $event"
          @check-whitelabel="whitelabel = $event" v-if="step == 3"></RegisterUpload>
      </v-slide-x-transition>

      <v-slide-x-transition v-if="!switchForm">
        <RegisterWhitelabel :hash="hash" :country="country" :assets="assets" @set-hash="setHash($event)"
          @set-generic-error="setGenericError($event)" @change-step="step = $event" v-if="step == 4">
        </RegisterWhitelabel>
      </v-slide-x-transition>
      <v-slide-x-transition v-if="!switchForm">
        <RegisterLegal :assets="assets" :country="country" :hash="hash" @set-hash="setHash($event)"
          @set-generic-error="setGenericError($event)" @change-step="step = $event" v-if="step == 5"></RegisterLegal>
      </v-slide-x-transition>

      <v-slide-x-transition>
        <v-card tile class="mx-auto mt-15 mb-3 pa-3" :loading="loading" max-width="768"
          v-if="(switchForm && step == 4)">
          <v-card-text>
            <v-row>
              <v-col>
                <div class="text-h5 text-center pb-2 pt-6 font-weight-bold green--text">Parabéns, cadastro concluído!
                </div>
                <div class="text-body-1 text-center pb-2 pt-6 font-weight-regular black--text">Enviamos um e-mail para
                  confirmação da sua conta.<br>Nossa equipe entrará em contato com você em breve."</div>
                <div class="text-body-1 text-center pb-2 pt-6 font-weight-medium black--text">Abraços,<br>
                  Equipe The Media Trade
                </div>
              </v-col>
            </v-row>
            <v-item-group>
              <div class="d-flex justify-center pt-9">
                <v-btn text color="primary" href="https://bgs.themediatrade.com" target="_blank">

                  <!-- <v-icon class="mr-2">mdi-video</v-icon> -->
                  Loja BGS
                  <v-icon class="ml-3" small>mdi-arrow-top-right</v-icon>
                </v-btn>
                <v-btn text color="primary" href="https://www.themediatrade.com" target="_blank">
                  <!-- <v-icon class="mr-2">mdi-video</v-icon> -->
                  Não conhecia a The Media Trade?
                  <v-icon class="ml-3" small>mdi-arrow-top-right</v-icon>
                </v-btn>
              </div>
            </v-item-group>

          </v-card-text>
        </v-card>
        <v-card class="mx-auto mt-15 mb-3 pa-3" :loading="loading" max-width="768" v-if="(!switchForm && step == 6)">
          <v-card-title class="green--text">
            <span>{{ $t('register.steps.conclusion.title') }}</span>
          </v-card-title>
          <v-card-text>
            <div class="d-flex">

              <div class="text-justify" v-html="$t('register.steps.conclusion.text')"></div>
              <v-img src="https://lion-web-site.s3.amazonaws.com/public/success_sent.svg" height="220"
                class="mx-3 mt-n12" width="300" cover position="top"></v-img>
            </div>
            <v-item-group>
              <div class="d-flex">
                <v-item v-slot="{ active, toggle }">
                  <v-card :color="active ? 'success' : 'success'" dark max-width="300" outlined elevation="0"
                    class="d-flex align-center px-3 mt-3 py-3 text-p justify-space-between" @click="toggle" :href="'/'">
                    <strong>
                      <!-- <v-icon class="mr-2">mdi-video</v-icon> -->
                      {{ $t('register.steps.conclusion.ctaText') }}
                    </strong>
                    <!-- <v-icon>mdi-arrow-right</v-icon> -->
                  </v-card>
                </v-item>
                <v-spacer></v-spacer>
              </div>
            </v-item-group>
            <v-row class="mt-2">
              <v-col cols="12" md="12" sm="12" class="d-flex">
                <v-card
                  href="https://wa.me/5511988729007?text=Olá%2C%20cadastrei%20meu%20veículo%20na%20The%20Media%20Trade%20e%20gostaria%20de%20mais%20informações"
                  target="_blank" class="py-3 px-5 d-flex align-center" color="primary" dark elevation="0">
                  <v-avatar size="22">
                    <svg width="20" height="20" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="19.4395" cy="19.4395" r="19.4395" fill="#49E670" class="color-element">
                      </circle>
                      <path
                        d="M12.9821 10.1115C12.7029 10.7767 11.5862 11.442 10.7486 11.575C10.1902 11.7081 9.35269 11.8411 6.84003 10.7767C3.48981 9.44628 1.39593 6.25317 1.25634 6.12012C1.11674 5.85403 2.13001e-06 4.39053 2.13001e-06 2.92702C2.13001e-06 1.46351 0.83755 0.665231 1.11673 0.399139C1.39592 0.133046 1.8147 1.01506e-06 2.23348 1.01506e-06C2.37307 1.01506e-06 2.51267 1.01506e-06 2.65226 1.01506e-06C2.93144 1.01506e-06 3.21063 -2.02219e-06 3.35022 0.532183C3.62941 1.19741 4.32736 2.66092 4.32736 2.79397C4.46696 2.92702 4.46696 3.19311 4.32736 3.32616C4.18777 3.59225 4.18777 3.59224 3.90858 3.85834C3.76899 3.99138 3.6294 4.12443 3.48981 4.39052C3.35022 4.52357 3.21063 4.78966 3.35022 5.05576C3.48981 5.32185 4.18777 6.38622 5.16491 7.18449C6.42125 8.24886 7.39839 8.51496 7.81717 8.78105C8.09636 8.91409 8.37554 8.9141 8.65472 8.648C8.93391 8.38191 9.21309 7.98277 9.49228 7.58363C9.77146 7.31754 10.0507 7.1845 10.3298 7.31754C10.609 7.45059 12.2841 8.11582 12.5633 8.38191C12.8425 8.51496 13.1217 8.648 13.1217 8.78105C13.1217 8.78105 13.1217 9.44628 12.9821 10.1115Z"
                        transform="translate(12.9597 12.9597)" fill="#FAFAFA"></path>
                      <path
                        d="M0.196998 23.295L0.131434 23.4862L0.323216 23.4223L5.52771 21.6875C7.4273 22.8471 9.47325 23.4274 11.6637 23.4274C18.134 23.4274 23.4274 18.134 23.4274 11.6637C23.4274 5.19344 18.134 -0.1 11.6637 -0.1C5.19344 -0.1 -0.1 5.19344 -0.1 11.6637C-0.1 13.9996 0.624492 16.3352 1.93021 18.2398L0.196998 23.295ZM5.87658 19.8847L5.84025 19.8665L5.80154 19.8788L2.78138 20.8398L3.73978 17.9646L3.75932 17.906L3.71562 17.8623L3.43104 17.5777C2.27704 15.8437 1.55796 13.8245 1.55796 11.6637C1.55796 6.03288 6.03288 1.55796 11.6637 1.55796C17.2945 1.55796 21.7695 6.03288 21.7695 11.6637C21.7695 17.2945 17.2945 21.7695 11.6637 21.7695C9.64222 21.7695 7.76778 21.1921 6.18227 20.039L6.17557 20.0342L6.16817 20.0305L5.87658 19.8847Z"
                        transform="translate(7.7758 7.77582)" fill="white" stroke="white" stroke-width="0.2"></path>
                    </svg>
                  </v-avatar>
                  <p class="pl-2 py-0 my-0">Enviar uma mensagem pelo WhatsApp</p>
                </v-card>
                <v-card href="mailto:parceiros@themediatrade.com" color="primary" target="_blank"
                  class="py-3 px-5 d-flex align-center ml-3" elevation="0" dark>
                  <v-avatar size="22">
                    <v-icon>mdi-email</v-icon>
                  </v-avatar>
                  <p class="pl-2 py-0 my-0">parceiros@themediatrade.com</p>
                </v-card>
              </v-col>


            </v-row>
          </v-card-text>

        </v-card>
      </v-slide-x-transition>
      <v-slide-x-transition v-if="!switchForm">
        <v-card class="mx-auto mt-15 mb-3 pa-3" :loading="loading" max-width="768" v-if="step == 7">
          <v-card-title class="green--text">
            <span>{{ $t('register.steps.whitelabel_conclusion.ctaText') }}</span>
          </v-card-title>
          <v-card-text>
            <div class="d-flex">

              <div v-html="$t('register.steps.whitelabel_conclusion.text')"></div>
              <v-img src="https://lion-web-site.s3.amazonaws.com/public/success_sent.svg" height="220" class="mx-3"
                width="300" cover position="top"></v-img>
            </div>
            <v-item-group>
              <div class="d-flex">
                <v-item v-slot="{ active, toggle }">
                  <v-card :color="active ? 'success' : 'success'" dark max-width="300" outlined elevation="0"
                    class="d-flex align-center px-3 mt-3 py-3 text-p justify-space-between" @click="toggle"
                    :href="lang == 'pt-BR' ? 'https://calendly.com/maggi-tmt-latam/15min' : 'https://calendly.com/eduardo-tmt-latam/15min'"
                    target="_blank">
                    <strong>
                      <v-icon class="mr-2">mdi-video</v-icon>
                      {{ $t('register.steps.conclusion.ctaText') }}
                    </strong>
                    <!-- <v-icon>mdi-arrow-right</v-icon> -->
                  </v-card>
                </v-item>
                <v-item v-slot="{ active, toggle }">
                  <v-card :color="active ? 'white' : 'white'" max-width="300" elevation="0"
                    class="d-flex align-center px-3 mx-2 mt-3 py-3 black--text text-p justify-space-between"
                    @click="toggle" href="/">
                    <strong>
                      <!-- <v-icon class="mr-2">mdi-video</v-icon> -->
                      {{ $t('register.steps.goHome') }}
                    </strong>
                    <!-- <v-icon>mdi-arrow-right</v-icon> -->
                  </v-card>
                </v-item>
                <v-item v-slot="{ active, toggle }">
                  <v-card :color="active ? 'white' : 'white'" dark max-width="300" elevation="0"
                    class="d-flex align-center px-3 mt-3 py-3 black--text text-p justify-space-between" @click="toggle"
                    href="https://store.themediatrade.com" target="_blank">
                    <strong>
                      <!-- <v-icon class="mr-2">mdi-video</v-icon> -->
                      {{ $t('register.steps.goStore') }}
                    </strong>
                    <!-- <v-icon>mdi-arrow-top-right</v-icon> -->
                  </v-card>
                </v-item>
              </div>
            </v-item-group>

          </v-card-text>

        </v-card>
      </v-slide-x-transition>
    </div>
    <div v-if="!readyToRender">
      <v-progress-linear indeterminate></v-progress-linear>
    </div>
    <!-- <v-slide-x-transition>
      <auth-password :user="user" v-if="page == 'password'" @setPage="changePage($event)" @error="error = $event"></auth-password>
    </v-slide-x-transition>
    <v-slide-x-transition>
      <auth-recovery :user="user" v-if="page == 'recovery'" :page="page" @setToken="setToken($event)" @setPage="changePage($event)" @error="error = $event"></auth-recovery>
    </v-slide-x-transition>
    <v-slide-x-transition>
      <auth-reset :user="user" v-if="page == 'reset'" @setPage="changePage($event)" @error="error = $event"></auth-reset>
    </v-slide-x-transition> -->
    <v-snackbar style="top: 70px" centered v-model="error.show" :timeout="10000" fixed bottom color="red">
      <div v-html="$t(error.text.text)"></div>
      <template v-slot:action="{ attrs }">
        <v-btn color="red" small fab elevation="0" v-bind="attrs" @click="error.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-footer dark>
      <v-container class="py-12" dark>
        <div class="d-flex justify-space-between px-6 pb-9  flex-wrap">
          <div class="px-4">
            <v-img src="@/assets/logo.svg" width="100"></v-img>
            <div class="text-p">
              © 2015-{{ year }} The Media Trade<br>23.659.903/0001-84<br>{{ $t('footer.copy') }}
            </div>
          </div>
          <div class="d-flex ma-3 flex-md-row flex-column">
            <div class="d-flex flex-column align-start">
              <div class="text-h6 mx-4">{{ $t('footer.company.title') }}</div>
              <v-btn text v-for="(item, index) in $t('footer.company.links')" :key="index" :href="item.link">{{
                item.text
              }}</v-btn>

            </div>
            <div class="d-flex flex-column align-start">
              <div class="text-h6 mx-4">{{ $t('footer.follow_us.title') }}</div>
              <v-btn text target="_blank" href="https://www.linkedin.com/company/media-trade"><v-icon
                  class="mr-2">mdi-linkedin</v-icon>LinkedIn <v-icon small
                  class="ml-6">mdi-arrow-top-right</v-icon></v-btn>
              <v-btn color="white" large class="mx-4 mt-9 primary--text" href="https://store.themediatrade.com"
                target="_blank">The Media Store <v-icon small class="ml-6">mdi-arrow-top-right</v-icon></v-btn>
            </div>
          </div>
        </div>
        <div class="mx-n4">
          <v-btn text small to="/politicas-de-cookie-e-privacidade">{{
            $t('footer.privacy') }}</v-btn>
          <v-divider vertical></v-divider>
          <v-btn text small to="/politicas-de-cookie-e-privacidade">{{
            $t('footer.terms') }}</v-btn>
        </div>
      </v-container>
    </v-footer>
  </div>
</template>
<script>
// import AuthUser from '@/components/auth/AuthUser.vue'
import moment from "moment"
import RegisterUser from '@/components/register/RegisterUser.vue';
import RegisterCompany from '@/components/register/RegisterCompany.vue';
import RegisterLegal from '@/components/register/RegisterLegal.vue';
import RegisterUpload from '@/components/register/RegisterUpload.vue';
import RegisterWhitelabel from '@/components/register/RegisterWhitelabel.vue';

export default {
  name: "RegisterView",
  components: {
    // AuthUser, AuthPassword, AuthRecovery, AuthReset, 
    RegisterUser,
    RegisterCompany,
    RegisterLegal,
    RegisterUpload,
    RegisterWhitelabel
  },
  mounted() {
    window.scrollTo(0, 0)
    this.hash = this.$route.query.hash ? this.$route.query.hash : ""
    this.step = this.$route.query.step ? this.$route.query.step : 1
    const location = this.$route.query.loc ? this.$route.query.loc : 'BRA'
    this.switchForm = this.$route.params.p ? this.$route.params.p : ""
    const foundLoc = this.assets.countries.find((c) => {
      return c.code == location
    })
    if (foundLoc) {
      this.country = foundLoc.index
    }
    this.readyToRender = true
  },
  data: () => ({
    whitelabel: true,
    genericErrors: [],
    hash: "",
    userPhone: "",
    country: 0,
    user: {},
    page: 'user',
    step: 1,
    switchForm: "",
    readyToRender: false,
    error: {
      text: "",
      show: false
    },
    assets: {
      countries: [
        {
          name: 'Brasil',
          currency: 'BRL',
          code: 'BRA',
          flag: 'bra.svg',
          lang: 'es',
          phoneMasks: '+55 (##) ####-#####',
          phonePlaceholder: '+55 (00) 0000-0000',
          phoneMinLength: 18,
          index: 0,
          personalDocument: 'CPF',
          personalDocumentMask: '###.###.###-##',
          companyDocument: 'CNPJ',
          companyDocumentMask: '##.###.###/####-##',
          zipCodeMask: '#####-###'
        },

        {
          name: 'Chile',
          currency: 'CHI',
          code: 'CHI',
          flag: 'chi.svg',
          lang: 'es',
          phoneMasks: '+56 ## #-###-###',
          phonePlaceholder: '+56 00 0-000-000',
          phoneMinLength: 15,
          index: 1,
          personalDocument: 'RUN',
          personalDocumentMask: '##.###.###-#',
          companyDocument: 'RUT',
          companyDocumentMask: '##.###.###-#',
          zipCodeMask: '### ####'
        },
        {
          name: 'Colombia',
          currency: 'COL',
          code: 'COL',
          flag: 'col.svg',
          lang: 'es',
          phoneMasks: '+57 ##-########',
          phonePlaceholder: '+57 00-0000000',
          phoneMinLength: 15,
          index: 2,
          personalDocument: 'RUT',
          personalDocumentMask: '##.###.###-#',
          companyDocument: 'NIT',
          companyDocumentMask: '##.###.###-#',
          zipCodeMask: '######'
        },

        {
          name: 'Mexico',
          currency: 'MEX',
          code: 'MEX',
          flag: 'mex.svg',
          lang: 'es',
          phoneMasks: '+52 ### #######',
          phonePlaceholder: '+52 000 0000000',
          phoneMinLength: 15,
          index: 3,
          personalDocument: 'CURP',
          personalDocumentMask: 'AAAA######AAAAAA##',
          companyDocument: 'RUT',
          companyDocumentMask: '##.###.###-#',
          zipCodeMask: '#####'
        },
        {
          name: 'Peru',
          currency: 'SOL',
          code: 'PER',
          flag: 'per.svg',
          lang: 'es',
          phoneMasks: '+51 ### ### ###',
          phonePlaceholder: '+51 000 000 000',
          phoneMinLength: 14,
          index: 4,
          personalDocument: 'DNI',
          personalDocumentMask: '########-#',
          companyDocument: 'RUC',
          companyDocumentMask: '###########',
          zipCodeMask: '#####'
        },

      ]
    },
  }),
  computed: {
    year() {
      return moment().format('Y')
    },
    isWhitelabel() { return this.$route.query.hasOwnProperty('isWhitelabel') ? true : false },
    lang() {
      return this.$i18n.locale
    }
  },
  methods: {
    goToPage() {
      this.$router.push('/whitelabel')
      this.$nextTick(() => {
        window.scrollTo(0, 0)
      })
    },
    setHash(event) {
      console.log('event', event)
      this.hash = event.hash
      if (event.phone) this.userPhone = event.phone
      if (event.interaction == 'publisher.profiled') {
        this.step = 2
      }

      if (event.interaction == 'publisher.upload') {
        this.step = 3
      }
      if (this.switchForm) {
        if (event.interaction == 'publisher.done') {
          this.step = 4
        }
      } else {
        if (event.interaction == 'publisher.whitelabel') {
          this.step = 4
        }
        if (event.interaction == 'publisher.confirmlegal') {
          this.step = 5
        }
        if (event.interaction == 'publisher.done') {
          this.step = 6
        }
      }



    },
    setUser(event) {
      this.user = event
      this.changePage('password')
    },
    setToken(event) {
      this.user.token = event
      this.changePage('reset')
    },
    changePage(page) {
      this.page = ""
      setTimeout(() => {
        this.page = page
      }, 300)
    },
    setGenericError(event) {
      console.log('setting generic error', event)
      this.error.text = event
      this.error.show = true
    }
  }
}
</script>
<style lang="scss">
.--disabled-step {
  opacity: 0.25;
  cursor: not-allowed;
}

.step-head {
  border-radius: 4px;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, .2), 0px 2px 2px 0px rgba(0, 0, 0, .14), 0px 1px 5px 0px rgb(0, 0, 0, .12), 0 -50px 0 #ffffff, -10px -5px 0 #ffffff, 10px -5px 0 #ffffff, 10px 0 0 #ffffff;
}

.--register-stepper {
  height: 100px;
}

.--register-stepper .v-stepper__header {
  position: relative;
  z-index: 3;
  width: 100%;
  background: #fff;
  height: 100px;
  max-width: 768px;
  border-radius: 4px;
  border: 1px solid rgb(228, 228, 228);
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, .2), 0px 2px 2px 0px rgba(0, 0, 0, .14), 0px 1px 5px 0px rgb(0, 0, 0, .12), 0 -50px 0 #ffffff, -10px -5px 0 #ffffff, 10px -5px 0 #ffffff, 10px 0 0 #ffffff;

  &.--top-extra {
    padding-top: 25px;
  }
}

.register-title {
  z-index: 10;
  position: relative;
}
</style>